import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import MusicSection from '../components/MusicSection';
import About from '../components/About';
import WritingSection from '../components/WritingSection';
import Testimonials from '../components/Testimonials';
import Events from '../components/Events';
import Footer from '../components/Footer';
import { fetchArtist, fetchMusic, fetchWriting, fetchEvents, fetchTestimonials } from '../services/api';

const HomePage = () => {
  const [artistData, setArtistData] = useState(null);
  const [musicData, setMusicData] = useState([]);
  const [writingData, setWritingData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [testimonialsData, setTestimonialsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        
        // Fetch all data in parallel
        const [artist, music, writing, events, testimonials] = await Promise.all([
          fetchArtist(),
          fetchMusic(),
          fetchWriting(),
          fetchEvents(),
          fetchTestimonials()
        ]);
        
        setArtistData(artist);
        setMusicData(music);
        setWritingData(writing);
        setEventsData(events);
        setTestimonialsData(testimonials);
        
        setLoading(false);
      } catch (err) {
        console.error('Error loading data:', err);
        setError('Failed to load content. Please try again later.');
        setLoading(false);
      }
    };
    
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen geometric-bg flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400 text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen geometric-bg flex items-center justify-center">
        <div className="text-center max-w-md px-6">
          <p className="text-red-400 text-lg mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-6 py-3 bg-[#D4AF37] text-black hover:bg-[#FFB547] transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen geometric-bg">
      <Header />
      <Hero artistData={artistData} />
      <MusicSection musicData={musicData} />
      <About artistData={artistData} />
      <WritingSection writingData={writingData} />
      <Testimonials testimonialsData={testimonialsData} />
      <Events eventsData={eventsData} />
      <Footer artistData={artistData} />
    </div>
  );
};

export default HomePage;